export default __webpack_public_path__ + "assets/models/ec1f584a20c205f3e31e01a800881dd3.glb";